export default {"src":"/_next/static/media/location-pin.bc866e8d.svg","height":18,"width":16};